import { useCallback } from "react";

import ChevronBottom from "@/design-system/icons/chevron-bottom";
import ChevronLeft from "@/design-system/icons/chevron-left";
import * as stylex from "@stylexjs/stylex";

import type { PropsWithStyleX } from "../../styles/tokens.stylex";

export interface IArrowIcon extends PropsWithStyleX {
    direction?: ArrowIconDirection;
}

export type ArrowIconDirection = "right" | "left" | "down" | "up";

export default function ArrowIcon({ direction = "down", styleX }: IArrowIcon) {
    const icon = useCallback(() => {
        switch (direction) {
            case "right":
            case "left":
                return <ChevronLeft />;
            case "up":
            default:
                return <ChevronBottom />;
        }
    }, [direction]);

    const rotated = direction === "right" || direction === "up";

    return <div {...stylex.props(styles.arrow, rotated && styles.arrowRotate, styleX)}>{icon()}</div>;
}

const styles = stylex.create({
    arrow: {
        flexGrow: 0,
        height: 24,
        strokeWidth: 2,
        transitionDuration: "180ms",
        transitionProperty: "transform",
        transitionTimingFunction: "ease-out",
        width: 24,
    },

    arrowRotate: {
        transform: "rotate(180deg)",
    },
});
